module.exports = __webpack_public_path__ + "static/media/textProduct_Katalog.7abdd636.md";